export default __webpack_public_path__ + "static/media/wow-pink-14px.3feec2bd.svg";